//messages.js
export default {
    import_id: "Import #",
    file_name: "File Name",
    total_records_imported: "# Imported",
    user_id: "User Id",
    edit_data_import_log: "Data Import Log",
    add_data_import_log: "Import CSV",
    delete_data_import_log: "Delete Data Import Log",
    data_import_logs: "Data Imports",
    delete_data_import_log_confirm: "This action is not reversible!",
    upload: "Upload",
};
